module.exports = __webpack_public_path__ + "static/media/ic-lock-open.f230750e.svg";